/**
 * Created by hernanherreros on 2019-05-06
 */

import * as React from 'react'
import { ComponentClass } from 'react'
import Information from '../containers/Wizard/Information'
import Payment from '../containers/Wizard/Payment'
import { Trans } from '@lingui/macro'
import Success from "../containers/Wizard/Success"

export interface RouterItem {
  path?: string;
  slug: string;
  label: string | React.ReactNode;
  help?: string | React.ReactNode;
  component?: ComponentClass<any> | null;
  icon?: string;
  number: number;
  subMenuItems?: RouterItem[];
  nextButtonLabel?: string | React.ReactNode;
}

export const defaultSteps = ['information', 'payment', 'success']

export const formRouterConfig: RouterItem[] = [
  {
    path: '/:congressSlug/wizard/:token/information',
    slug: 'information',
    label: <Trans>Ingrese su Información</Trans>,
    help: <Trans>Ingrese su información</Trans>,
    number: 1,
    component: Information,
  },
  {
    path: '/:congressSlug/wizard/:token/success',
    slug: 'success',
    label: <Trans>¡Último paso!</Trans>,
    help: <Trans>Descubra la información</Trans>,
    nextButtonLabel: <Trans>Finalizar Registro</Trans>,
    number: 2,
    component: Success,
  },
]

export const defaultPrimaryColor = '#999999'
